module.exports = __webpack_public_path__ + "img/menu-xinxi.1f0c7ab2.svg";